var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrivers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.561,
    height: 28.014,
    viewBox: "0 0 31.561 28.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.257 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.84,12.177c-2.963,0-5.375-2.731-5.375-6.088S5.877,0,8.84,0s5.373,2.732,5.373,6.088S11.8,12.177,8.84,12.177M8.84,1.4c-2.193,0-3.977,2.1-3.977,4.69s1.784,4.69,3.977,4.69,3.974-2.1,3.974-4.69S11.032,1.4,8.84,1.4",
    transform: "translate(1.38 0)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.106,23.233H1.1a.7.7,0,0,1-.7-.652l-.4-5.809a5.264,5.264,0,0,1,3.279-4.848,20.293,20.293,0,0,1,13.628,0A5.247,5.247,0,0,1,20.2,16.776l-.4,5.806a.7.7,0,0,1-.7.652m-17.351-1.4h16.7l.351-5.156a3.847,3.847,0,0,0-2.365-3.441,18.922,18.922,0,0,0-12.675,0A3.876,3.876,0,0,0,1.4,16.681Z",
    transform: "translate(0 4.281)",
    fill: "#edbb5f",
    stroke: "#edbb5f",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.106,23.233H1.1a.7.7,0,0,1-.7-.652l-.4-5.809a5.264,5.264,0,0,1,3.279-4.848,20.293,20.293,0,0,1,13.628,0A5.247,5.247,0,0,1,20.2,16.776l-.4,5.806a.7.7,0,0,1-.7.652m-17.351-1.4h16.7l.351-5.156a3.847,3.847,0,0,0-2.365-3.441,18.922,18.922,0,0,0-12.675,0A3.876,3.876,0,0,0,1.4,16.681Z",
    transform: "translate(0 4.281)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.775,22.8H16.606a.7.7,0,1,1,0-1.4h6.516l.3-4.364a3.276,3.276,0,0,0-1.983-2.876,16.057,16.057,0,0,0-5.132-.933.7.7,0,0,1-.687-.712.715.715,0,0,1,.712-.687,17.434,17.434,0,0,1,5.584,1.017,4.639,4.639,0,0,1,2.9,4.287l-.344,5.016a.7.7,0,0,1-.7.65",
    transform: "translate(6.222 4.713)",
    fill: "#002a2e",
    stroke: "#002a2e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.745,12.555a4.653,4.653,0,0,1-4.346-4.9,4.654,4.654,0,0,1,4.346-4.9,4.651,4.651,0,0,1,4.341,4.9,4.651,4.651,0,0,1-4.341,4.9m0-8.4a3.265,3.265,0,0,0-2.948,3.5,3.263,3.263,0,0,0,2.948,3.5,3.262,3.262,0,0,0,2.942-3.5,3.264,3.264,0,0,0-2.942-3.5",
    transform: "translate(5.735 1.097)",
    fill: "#002a2e",
    stroke: "#002a2e",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivers);
export default __webpack_public_path__ + "static/media/drivers.a92d2a29fc383e9b44260122b8568ff6.svg";
export { ForwardRef as ReactComponent };